import { init } from '@kiute-tech/network-kiute-pro';

const { PUBLIC_URL } = process.env;

const {
    REACT_APP_MKP_ES_URL,
    REACT_APP_MKP_API_URL,
    REACT_APP_SAAS_API_URL,
} = process.env;

const options = {
    mkpEsUrl: REACT_APP_MKP_ES_URL,
    mkpApiUrl: REACT_APP_MKP_API_URL,
    saasApiUrl: REACT_APP_SAAS_API_URL,
    loginUrl: `${PUBLIC_URL}login`,
};

const {
    auth,
    activity,
    booking,
    company,
    customer,
    discount,
    logicalDay,
    resource,
    sale,
    catalog,
    appConfig,
    notifications,
} = init(options);

export {
    auth,
    activity,
    booking,
    company,
    customer,
    discount,
    logicalDay,
    resource,
    sale,
    catalog,
    appConfig,
    notifications,
};
